import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw9321Api, QueryParams, LeaveRow } from '../../../services/pw9321Api';

export function usePW9321Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<LeaveRow[]>([]);
  const [totalDay, setTotalDay] = useState(0);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pw9321Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setTotalDay(resp.total_day || 0);
        setNoData(false);
      } else {
        setData([]);
        setTotalDay(0);
        setNoData(true);
        message.info(resp.message || '查無符合條件的請假資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setTotalDay(0);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, totalDay, queried, noData, runQuery, reset };
}
